import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// redux
import { combineReducers } from 'redux';
import CoreReduxStore from '@/core/reducers/CoreReduxStore';
// action
import ActionCore from '@/core/actions/ActionCore';
import EActionStatus from "@/core/enums/EActionStatus";
// store
import AppStore from "@/app-store";
import EReduxStoreInitialState from "@/core/enums/EReduxStoreInitialState";


type TPayload = {

    filters:string|null;
    orders:string|null;
    top:number;
    skip:number;

    lastPage:number
    currentPage:number;

    scrollTo:boolean;
    hasSearch:boolean;

}

type TusePagePayload = {

    payload:TPayload;
    modifySearchPageStore:( payload:any ) => void;
    setHasSearchFalse:() => void;
    setLastPage:( lastPage:number ) => void;
    setScrollTo:( value:boolean ) => void;

}

const Store = ( screenCode:string ) => {
    const reduxStorages = new CoreReduxStore({ screenCode: screenCode, serviceCode: "" });

    return combineReducers({

        SearchPageStore: reduxStorages.BASE({ 
            storeKey: "search",
            protocolKey: "",
            initialState: EReduxStoreInitialState.OBJECT
        })["search"]
    
    });
}

class Action extends ActionCore {

    constructor( dispatch:any, screenCode:string ) {
        super( dispatch, null, screenCode );
    }

    async modify ( payload: any ) {
        super.modify("", payload);
    }

    clean () {
        this.dispatch({ type: `${this.screenCode}${EActionStatus.CLEAN}` });
    }

}

const usePagePayload = ( unqKey:string ):TusePagePayload|null => {
    const dispatch = useDispatch();

    const _unqKey= unqKey ? `${unqKey}PP` : undefined;
    const payload = useSelector((state:any) => _unqKey ? state?.[_unqKey]?.SearchPageStore?.payload : undefined, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(_unqKey); } }, [])

    if ( !_unqKey ) return null;

    const action = new Action(dispatch, _unqKey);
    AppStore.reducerManager.add(_unqKey, Store(_unqKey));

    const modifySearchPageStore = ( payload:any ) => {
        action.modify(payload);
    }

    const setHasSearchFalse = () => {
        action.modify([
            { key:"hasSearch", value: false },
        ]);
    }

    const setLastPage = ( lastPage:number ) => {
        action.modify([
            {key:"lastPage", value: lastPage},
        ]);
    }

    const setScrollTo = ( value:boolean ) => {
        action.modify([
            {key:"scrollTo", value},
        ]);
    }

    return {
        payload,
        modifySearchPageStore,
        setHasSearchFalse,
        setLastPage,
        setScrollTo
    };
}

export default usePagePayload;
